import type { NavGroup, PathBuilder, Translate } from './types';

import { WrenchIcon } from '@valwin/facto/icons';

import { ROUTES } from '~shared/routes';

export function buildValwinGroup(
  buildPath: PathBuilder,
  t: Translate
): NavGroup {
  return {
    kind: 'group',
    id: 'valwin',
    label: t('menu valwin'),
    icon: WrenchIcon,
    children: [
      {
        kind: 'link',
        id: 'admin-groups',
        label: t('menu groups'),
        to: buildPath(ROUTES.admin.groups.root),
      },
      {
        kind: 'link',
        id: 'admin-pharmacies',
        label: t('menu pharmacies'),
        to: buildPath(ROUTES.admin.pharmacies.root),
      },
      {
        kind: 'group',
        id: 'admin-content',
        label: t('menu contentManagement'),
        children: [
          {
            kind: 'link',
            id: 'admin-linings',
            label: t('menu ranges'),
            to: buildPath(ROUTES.admin.content.linings),
          },
          {
            kind: 'link',
            id: 'admin-services',
            label: t('menu services'),
            to: buildPath(ROUTES.admin.content.services),
          },
          {
            kind: 'link',
            id: 'admin-specialities',
            label: t('menu specialities'),
            to: buildPath(ROUTES.admin.content.specialities),
          },
          {
            kind: 'link',
            id: 'admin-pharmacies-db',
            label: t('menu pharmaciesDB'),
            to: buildPath(ROUTES.admin.content.pharmacies),
          },
          {
            kind: 'link',
            id: 'admin-videos',
            label: t('menu videos'),
            to: buildPath(ROUTES.admin.content.videos),
          },
          {
            kind: 'link',
            id: 'admin-tips',
            label: t('menu usefulInfo'),
            to: buildPath(ROUTES.admin.content.tips),
          },
          {
            kind: 'link',
            id: 'admin-forms',
            label: t('menu questionnaires'),
            to: buildPath(ROUTES.admin.content.forms),
          },
        ],
      },
    ],
  };
}
